import './style.scss';
import React, {PropTypes} from 'react';
import Modal from 'routes/app/components/Modal';
import _ from 'lodash';

import Day from './Day';

const TimeSlotModal = ({data, config, translateFn, onOpen, ...props}) => {
    let hasData = Object.keys(data).length !== 0;

    return (
        <Modal
            header={translateFn({id:'timeslotpicker.modal.title'})}
            textDisagree={translateFn({id:'button.close'})}
            agreeElement=" "
            className="tsp-modal"
            trigger={
                        <button className="tsp-btn" onClick={onOpen}>
                            <i className="material-icons">access_time</i>
                        </button>
                    }
            >
            <div>
                {!hasData && translateFn({id:'timeslotpicker.modal.selectdate'})}
                {hasData && _.map(data, (day, key) => (
                    <Day key={key} day={key} data={day} begin={config.begin} end={config.end} translate={translateFn} {...props}/>
                ))}
            </div>
        </Modal>
    );
};

TimeSlotModal.propTypes = {
    translateFn: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
    data: PropTypes.object,
    config: PropTypes.object
};

export default TimeSlotModal;
